module.exports = __webpack_public_path__ + "img/pressureRoad-icon0.6ea05e3c.png";